import {CalculatorBase} from "./CalculatorBase";
import {NumericUtilities} from "../../Utilities/NumericUtilities";

export class PricePerItemCalculator extends CalculatorBase{

    private CustomSalePrice:number;
    private CustomRegularPrice:number;

    constructor() {
        super();
        this.CustomSalePrice=null;
        this.CustomRegularPrice=null;

    }


    public SetRegularPrice(price:any)
    {
        this.CustomRegularPrice=price;
        return this;
    }

    public SetSalePrice(price:any)
    {
        this.CustomSalePrice=price;
        return this;
    }

    public ExecuteCalculation(value:any):{RegularPrice:any,SalePrice:any,Quantity:number}   {
        if(value==null)
            value=this.Field.GetValue();

        let regularPriceToUse=this.CustomRegularPrice!=null?this.CustomRegularPrice:this.Field.GetRegularPrice();
        let salePriceToUse=this.CustomSalePrice!=null?this.CustomSalePrice:this.Field.GetSalePrice();

        if(salePriceToUse!='')
            salePriceToUse=NumericUtilities.ParseNumber(salePriceToUse)*value.length;

        if(regularPriceToUse!='')
            regularPriceToUse=NumericUtilities.ParseNumber(regularPriceToUse)*value.length;
        if(value.length>0) {
            if(salePriceToUse!='') {

                return {
                    Quantity:this.GetQuantityInput(),
                    RegularPrice:regularPriceToUse,
                    SalePrice:salePriceToUse
                };
            }
            else
                return {RegularPrice:regularPriceToUse,SalePrice:'',Quantity:this.GetQuantityInput()};
        }
        else
            return {SalePrice:'',RegularPrice:'',Quantity:0}
    }





    public ParseNumber(number:any)
    {
        let num=parseFloat(number);
        if(isNaN(num))
            return 0;
        return num;
    }

}